/**
 * Do not edit directly — generated by `pnpm build-tokens`.
 */

import { theme as AntdTheme, type ThemeConfig } from 'antd';

const { darkAlgorithm, defaultAlgorithm } = AntdTheme;

export const antdThemes: Record<"light" | "dark", ThemeConfig> = {
  light: {
    algorithm: defaultAlgorithm,
    token: {
      colorBgContainerDisabled: "#f3f5f7",
      colorInfoBg: "#ebeefb",
      colorPrimary: "#d2f740",
      colorText: "#0c0c0b",
      colorLink: "#0c0c0b",
      colorLinkHover: "#0c0c0b",
      colorLinkActive: "#0c0c0b",
      colorTextLightSolid: "#0c0c0b",
      colorPrimaryHover: "#b3d049",
      colorBgMask: "rgba(21, 21, 20, 0.4)",
      fontFamily: "'Proxima Nova', sans-serif",
      borderRadius: 4,
      fontSize: 14,
      colorTextBase: "#0c0c0b",
      colorBgBase: "#fafafa",
      colorPrimaryActive: "#d2f740",
      colorBorder: "#e6e6e6",
      colorBorderSecondary: "#e6e6e6",
      colorTextPlaceholder: "#767676",
      colorTextDisabled: "#808080",
      colorTextDescription: "#4d4d4d",
      colorTextHeading: "#0c0c0b",
      colorBgContainer: "#ffffff",
      colorBgElevated: "#f3f5f7",
      colorBgLayout: "#fafafa",
      wireframe: false,
      motion: true,
      fontFamilyCode: "Roboto Mono",
      boxShadow: "0px 0px 6px 0px rgba(12, 12, 11, 0.08)",
      boxShadowSecondary: "0px 2px 16px 0px rgba(12, 12, 11, 0.04)",
      fontWeightStrong: 700,
      borderRadiusXS: 2,
      borderRadiusSM: 4,
      borderRadiusLG: 8,
      sizeUnit: 4,
      sizeStep: 4,
      lineWidth: 1,
      fontSizeSM: 12,
      fontSizeLG: 16,
      fontSizeXL: 20,
      fontSizeHeading1: 28,
      fontSizeHeading2: 24,
      fontSizeHeading3: 20,
      fontSizeHeading4: 16,
      fontSizeHeading5: 14
    },
    components: {
      Collapse: {
        colorBgContainer: "#ffffff",
        colorFillAlter: "#ffffff",
        colorTextHeading: "#0c0c0b",
        paddingSM: 24,
        padding: 24
      },
      Menu: {
        itemSelectedBg: "#d2f740",
        colorTextDisabled: "#4d4d4d",
        itemMarginInline: 0,
        itemBorderRadius: 0
      },
      Table: {
        colorFillAlter: "#ffffff",
        colorTextHeading: "#0c0c0b",
        colorBgContainer: "#ffffff",
        fontWeightStrong: 400,
        colorPrimary: "#b3d049"
      },
      Tabs: {
        cardBg: "#151514",
        colorBorder: "transparent"
      },
      Tooltip: {
        colorTextLightSolid: "#ffffff",
        colorBgSpotlight: "#283102",
        zIndexPopup: 1600
      },
      Drawer: {
        colorBgElevated: "#f3f5f7",
        zIndexPopup: 1200
      },
      DatePicker: {
        colorPrimary: "#396b00"
      },
      Input: {
        colorPrimaryHover: "#396b00",
        controlHeight: 24
      },
      InputNumber: {
        colorPrimaryHover: "#396b00",
        controlHeight: 24
      },
      Select: {
        colorPrimaryHover: "#396b00",
        colorTextPlaceholder: "#4d4d4d",
        controlHeight: 24,
        controlHeightSM: 24,
        fontSize: 12,
        controlItemBgActive: "#f3f5f7",
        zIndexPopup: 1000
      },
      Radio: {
        colorPrimary: "#396b00",
        colorPrimaryHover: "#396b00",
        colorPrimaryActive: "#396b00"
      },
      Checkbox: {
        colorPrimary: "#d2f740",
        colorPrimaryHover: "#d2f740"
      },
      Pagination: {
        colorPrimary: "#b3d049",
        colorPrimaryHover: "#b3d049"
      },
      Steps: {
        colorPrimary: "#d2f740",
        colorPrimaryHover: "#d2f740"
      },
      Switch: {
        colorPrimary: "#d2f740",
        colorPrimaryHover: "#d2f740"
      },
      Spin: {
        colorPrimary: "#b3d049"
      },
      Card: {
        boxShadowTertiary: "none"
      },
      Button: {
        lineHeight: 1,
        controlOutlineWidth: 0
      },
      Dropdown: {
        fontSize: 12,
        zIndexPopup: 1000
      },
      Modal: {
        headerBg: "#ffffff",
        contentBg: "#ffffff",
        titleColor: "#0c0c0b",
        marginSM: 32,
        titleFontSize: 16,
        titleLineHeight: 1.375
      },
      Tag: {
        defaultBg: "#fafafa",
        defaultColor: "#4d4d4d"
      },
      List: {
        headerBg: "#ffffff",
        footerBg: "#ffffff",
        descriptionFontSize: 12
      },
      Descriptions: {
        labelBg: "#ffffff",
        extraColor: "#4d4d4d"
      },
      Divider: {
        colorSplit: "#bdeb0a"
      },
      Statistic: {
        titleFontSize: 16,
        contentFontSize: 24
      },
      Popover: {
        zIndexPopup: 1400
      },
      Message: {
        zIndexPopup: 1500
      },
      Notification: {
        zIndexPopup: 1500
      }
    }
  },
  dark: {
    algorithm: darkAlgorithm,
    token: {
      colorBgContainerDisabled: "#222423",
      colorInfoBg: "#050816",
      colorPrimary: "#d2f740",
      colorText: "#ffffff",
      colorLink: "#ffffff",
      colorLinkHover: "#ffffff",
      colorLinkActive: "#ffffff",
      colorTextLightSolid: "#ffffff",
      colorPrimaryHover: "#b3d049",
      colorBgMask: "rgba(21, 21, 20, 0.4)",
      fontFamily: "'Proxima Nova', sans-serif",
      borderRadius: 4,
      fontSize: 14,
      colorTextBase: "#ffffff",
      colorBgBase: "#222423",
      colorPrimaryActive: "#d2f740",
      colorBorder: "#4d4d4d",
      colorBorderSecondary: "#4d4d4d",
      colorTextPlaceholder: "#808080",
      colorTextDisabled: "#808080",
      colorTextDescription: "#edf0f3",
      colorTextHeading: "#ffffff",
      colorBgContainer: "#151514",
      colorBgElevated: "#222423",
      colorBgLayout: "#222423",
      wireframe: false,
      motion: true,
      fontFamilyCode: "Roboto Mono",
      boxShadow: "0px 0px 6px 0px rgba(12, 12, 11, 0.08)",
      boxShadowSecondary: "0px 2px 16px 0px rgba(12, 12, 11, 0.04)",
      fontWeightStrong: 700,
      borderRadiusXS: 2,
      borderRadiusSM: 4,
      borderRadiusLG: 8,
      sizeUnit: 4,
      sizeStep: 4,
      lineWidth: 1,
      fontSizeSM: 12,
      fontSizeLG: 16,
      fontSizeXL: 20,
      fontSizeHeading1: 28,
      fontSizeHeading2: 24,
      fontSizeHeading3: 20,
      fontSizeHeading4: 16,
      fontSizeHeading5: 14
    },
    components: {
      Collapse: {
        colorBgContainer: "#151514",
        colorFillAlter: "#151514",
        colorTextHeading: "#ffffff",
        paddingSM: 24,
        padding: 24
      },
      Menu: {
        itemSelectedBg: "#d2f740",
        colorTextDisabled: "#edf0f3",
        itemMarginInline: 0,
        itemBorderRadius: 0
      },
      Table: {
        colorFillAlter: "#151514",
        colorTextHeading: "#ffffff",
        colorBgContainer: "#151514",
        fontWeightStrong: 400,
        colorPrimary: "#b3d049"
      },
      Tabs: {
        cardBg: "#151514",
        colorBorder: "transparent"
      },
      Tooltip: {
        colorTextLightSolid: "#151514",
        colorBgSpotlight: "#283102",
        zIndexPopup: 1600
      },
      Drawer: {
        colorBgElevated: "#222423",
        zIndexPopup: 1200
      },
      DatePicker: {
        colorPrimary: "#396b00"
      },
      Input: {
        colorPrimaryHover: "#396b00",
        controlHeight: 24
      },
      InputNumber: {
        colorPrimaryHover: "#396b00",
        controlHeight: 24
      },
      Select: {
        colorPrimaryHover: "#396b00",
        colorTextPlaceholder: "#edf0f3",
        controlHeight: 24,
        controlHeightSM: 24,
        fontSize: 12,
        controlItemBgActive: "#222423",
        zIndexPopup: 1000
      },
      Radio: {
        colorPrimary: "#396b00",
        colorPrimaryHover: "#396b00",
        colorPrimaryActive: "#396b00"
      },
      Checkbox: {
        colorPrimary: "#d2f740",
        colorPrimaryHover: "#d2f740"
      },
      Pagination: {
        colorPrimary: "#b3d049",
        colorPrimaryHover: "#b3d049"
      },
      Steps: {
        colorPrimary: "#d2f740",
        colorPrimaryHover: "#d2f740"
      },
      Switch: {
        colorPrimary: "#d2f740",
        colorPrimaryHover: "#d2f740"
      },
      Spin: {
        colorPrimary: "#b3d049"
      },
      Card: {
        boxShadowTertiary: "none"
      },
      Button: {
        lineHeight: 1,
        controlOutlineWidth: 0
      },
      Dropdown: {
        fontSize: 12,
        zIndexPopup: 1000
      },
      Modal: {
        headerBg: "#151514",
        contentBg: "#151514",
        titleColor: "#ffffff",
        marginSM: 32,
        titleFontSize: 16,
        titleLineHeight: 1.375
      },
      Tag: {
        defaultBg: "#222423",
        defaultColor: "#edf0f3"
      },
      List: {
        headerBg: "#151514",
        footerBg: "#151514",
        descriptionFontSize: 12
      },
      Descriptions: {
        labelBg: "#151514",
        extraColor: "#edf0f3"
      },
      Divider: {
        colorSplit: "#d2f740"
      },
      Statistic: {
        titleFontSize: 16,
        contentFontSize: 24
      },
      Popover: {
        zIndexPopup: 1400
      },
      Message: {
        zIndexPopup: 1500
      },
      Notification: {
        zIndexPopup: 1500
      }
    }
  }
};

export type AntdThemeMode = keyof typeof antdThemes;

export const getAntdTheme = (mode: AntdThemeMode): ThemeConfig => antdThemes[mode];

export default antdThemes;
